import { useState, useEffect } from 'react'
import { useSelector } from 'react-redux'
import { selectRoadbookSummary } from '../../store/itinerary/expenseReport.selectors'

export const truncateDistanceToKM = (decimalLengthInMeter) => Math.round(decimalLengthInMeter / 100) / 10

export const computeKilometerCompensation = (compensationByKm, distanceInMeter) =>
  (truncateDistanceToKM(distanceInMeter) * compensationByKm).toFixed(2)

export const computeTotalAmount = (kmCompensation, gas, toll) => (kmCompensation + gas + toll).toFixed(2)

const useComputeExpenseReportCost = () => {
  const { gas = { value: 0 }, toll = { value: 0 }, distanceInMeter } = useSelector(selectRoadbookSummary)
  const [compensationByKm, setCompensationByKm] = useState(0)
  const [compensationTotal, setCompensationTotal] = useState(0)
  const [totalAmount, setTotalAmount] = useState((gas.value + toll.value).toFixed(2))

  useEffect(() => {
    setCompensationTotal(computeKilometerCompensation(compensationByKm, distanceInMeter))
  }, [compensationByKm, distanceInMeter])

  useEffect(() => {
    setTotalAmount(computeTotalAmount(parseFloat(compensationTotal), gas?.value ?? 0, toll?.value ?? 0))
  }, [compensationTotal, gas, toll])

  return {
    compensationByKm,
    compensationTotal,
    totalAmount,
    setCompensationByKm,
  }
}

export default useComputeExpenseReportCost
